import { ReactElement } from 'react';

import { Name, Email, MemberNumber, Telephone, TextArea } from '@/components/form-block/form-components';

const LongAnswerCompetition = (): ReactElement => {
  return (
    <>
      <Name />
      <Email />
      <Telephone />
      <MemberNumber />
      <TextArea labelText="Tell us your answer below" />
    </>
  );
};

export { LongAnswerCompetition };
